import React, { useEffect, useRef, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useConfirm, useToast } from '../UI/Toast';
import Auth from '../../pages/Auth/Auth';
import { AUTH_REQUIRED_EVENT, AUTH_REQUIRED_MESSAGE, AuthRequiredEventDetail } from '../../utils/authPrompt';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const lastAuthPromptAtRef = useRef(0);
  const { ToastWrapper, showToast } = useToast();
  const { ConfirmWrapper } = useConfirm();

  useEffect(() => {
    const handleAuthRequired = (event: Event) => {
      const detail = (event as CustomEvent<AuthRequiredEventDetail>).detail || {};
      const nextMessage = detail.message || AUTH_REQUIRED_MESSAGE;
      const now = Date.now();

      setIsAuthModalOpen(true);

      if (detail.showToast !== false && now - lastAuthPromptAtRef.current > 1500) {
        lastAuthPromptAtRef.current = now;
        showToast(nextMessage, 'info');
      }
    };

    const handleAuthChange = () => {
      if (localStorage.getItem('token')) {
        setIsAuthModalOpen(false);
      }
    };

    window.addEventListener(AUTH_REQUIRED_EVENT, handleAuthRequired as EventListener);
    window.addEventListener('auth-change', handleAuthChange);

    return () => {
      window.removeEventListener(AUTH_REQUIRED_EVENT, handleAuthRequired as EventListener);
      window.removeEventListener('auth-change', handleAuthChange);
    };
  }, [showToast]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ToastWrapper />
      <ConfirmWrapper />
      <Header onRequireAuth={() => setIsAuthModalOpen(true)} />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      {isAuthModalOpen && (
        <Auth isModal onClose={() => setIsAuthModalOpen(false)} />
      )}
    </div>
  );
};

export default Layout;
